import React, { useState } from "react";
import { Form, Input, Button, Typography, message, Spin, Divider, Row, Col } from "antd";
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";
import { RightOutlined ,ArrowRightOutlined } from '@ant-design/icons';
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
import Login from "../../components/Login/Login";
import {SENIOR_PRIVATE_BANKER_ROLE_ID} from "../../constants/DataConstants";

const { Title, Link } = Typography;

const AccountLogin = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Email: values.email,
                Password: values.password,
                IsBanker: "Banker",
                RoleId: SENIOR_PRIVATE_BANKER_ROLE_ID
            }
            const res = await _BankerService.bankerLogin(reqObj);
            console.log(res);
            if (res?.data.IsSuccess) {
                // message.success(res.data.Message);
                localStorage.setItem("IsLoanofficerFlag", JSON.stringify(false));
                localStorage.setItem("BankerEmailId", res?.data?.Obj?.Email);
                localStorage.setItem("BankerId", res?.data?.Obj?.Id);
                localStorage.setItem("BankerFirstName", res?.data?.Obj?.FirstName);
                localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
                localStorage.setItem("userRole", res?.data?.Obj?.Role);
                localStorage.setItem("RoleId", res?.data?.Obj?.RoleId);
                localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
                localStorage.setItem("listUserRoles", JSON.stringify(res?.data?.Obj?.listUserRoles));
                localStorage.setItem("Password", values.password);
                history.push(routes.bankerdashboard.path);
                setLoading(false);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG)
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        }

    };

    const forgotPassword = () => {
        history.push(routes.forgotBankerLoginPasswordSendOTP.path);
    };

    const bankerLogin = () => {
        history.push(routes.accountLogin.path);
    }

    const bankerAdminLogin = () => {
        history.push(routes.bankAdminLogin.path);
    }

    const loanOfficerLogin = () => {
        history.push(routes.accountLoginForLoanOfficer.path);
    }

    const complianceAdminLogin = () => {
        history.push(routes.complianceAdminLogin.path);
    }

    const applicantLogin = () => {
        history.push(routes.registeredEmail.path);
    }

    const createNewAccount = () => {
        history.push(routes.enterEmail.path);
    }

    return (
        <Spin spinning={loading}>
            <Login 
                role="banker"
                title="Banker's Portal"
                onFinishHandle={onFinish}
                createNewAccount={createNewAccount}
                forgotPassword={forgotPassword}
                bankerLogin={bankerLogin}
                bankerAdminLogin={bankerAdminLogin}
                loanOfficerLogin={loanOfficerLogin}
                complianceAdminLogin={complianceAdminLogin}
                isNewAccountCreateFlag={false}
                applicantLogin={applicantLogin}
            />
            {/* <LeftLayout>
                <div className="w450 bank-login-page">

                    <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 60 }}>
                        Banker's Portal
                    </Title>

                    <Form
                        name="account-login"
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={true}
                    >
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: "Email is required",
                                },
                                { type: 'email', message: 'Enter a valid Email' }
                                // {
                                //     pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in|org|net|edu|gov|co|ai|us|info|biz|me|io|tech|app|dev|cloud|store|xyz|tv|name|email|pro|mil|k12|state)$/,
                                //     message: "Please enter a valid email address with a valid domain (e.g., .com, .in)",
                                // },
                            ]}
                        >
                            <Input autoComplete="email" placeholder="Enter Your Email" maxLength={50} />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: "Password is required" }]}
                        >
                            <Input.Password autoComplete="current-password" placeholder="Enter Password" maxLength={30} />
                        </Form.Item>
                        <div style={{ textAlign: "right", marginTop: 8 }} className="forgot-text">
                            <Link
                                onClick={() => history.push(routes.forgotBankerLoginPasswordSendOTP.path)}
                                style={{ fontWeight: "bold" }}
                            >
                                Forgot Password? <RightOutlined />
                            </Link>
                        </div>

                        <Row justify="space-between" align="middle" style={{ marginTop: 8 }}>
                            <Col>
                                <Form.Item style={{ marginBottom: 0 }}>
                                    <Button
                                        htmlType="submit"
                                        className="login-btn"
                                        shape="round"
                                        style={{
                                            borderColor: "#001f3f",
                                            color: "#001f3f",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Login <RightOutlined />
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col className="displayNone">
                                <Link
                                    onClick={() => history.push(routes.enterEmail.path)}
                                    style={{ fontWeight: "bold" }}
                                >
                                    Create A New Account <RightOutlined />
                                </Link>
                            </Col>
                        </Row>

                    </Form>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: 15,
                        }}
                    >


                    </div>
                    <Divider plain orientation="center">
                        OR
                    </Divider>
                    <Form.Item className="mb10">
                        <Link onClick={() => history.push(routes.bankAdminLogin.path)}>
                            Bank Admin Login <RightOutlined />
                        </Link>
                    </Form.Item>
                    <Form.Item className="mb10">
                        <Link onClick={() => history.push(routes.registeredEmail.path)}>
                            Applicant Login <RightOutlined />
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Link onClick={() => history.push(routes.accountLoginForLoanOfficer.path)}>
                            Loan Officer Login <RightOutlined />
                        </Link>
                    </Form.Item>

                </div>
            </LeftLayout> */}
        </Spin>
    );
};

export default AccountLogin;
